// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useRef} from 'react';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {use_section_scroll} from '../../../../hola/pub/lib/use_section_scroll';
import cn from 'classnames';
import {useLocation} from 'react-router';
import {Button, i_button_props} from '../../../../hola/pub/lib/button';
import {Proxy_type} from '../../../../hola/pub/ui/pro/cp/orders';
import Icon_check from '../../img/icons/8/check.svg';
import Icon_datacenter from '../../img/icons/40/datacenter.svg';
import Icon_rotating_resi from '../../img/icons/40/rotating_resi.svg';
import Icon_search from '../../img/icons/40/search.svg';
import Icon_static_resi from '../../img/icons/40/static_resi.svg';
import Icon_question from '../../img/icons/40/question.svg';
import Icon_shared from '../../img/icons/40/shared.svg';
import styles from './product_cards.module.less';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {Input} from '../../../../hola/pub/lib/input';
import {Dynamic_heading, Title_header_select} from '../../../../shared/editor/title_header_select';
import {use_data_provider} from '../../../../hola/pub/lib/use_data_provider';

type i_product_card_cta = Pick<i_button_props, 'caption' | 'to' | 'size'
    | 'on_click'>;
interface i_product_card {
    id: Proxy_type;
    title: string;
    features: Array<string[]>;
    cta: i_product_card_cta;
    icon?: JSX.Element;
}
const product_cards: i_product_card[] = [
    {
        id: Proxy_type.SDC,
        title: 'Shared Datacenter Proxies',
        icon: <Icon_shared/>,
        features: [
            ['Budget-friendly and effective'],
            ['Great for general tasks'],
            ['Cost-effective'],
        ],
        cta: {caption: 'Try for free >', to: '/dashboard', size: 'md'},
    },
    {
        id: Proxy_type.DDC,
        title: 'Dedicated Datacenter Proxies',
        icon: <Icon_datacenter/>,
        features: [
            ['Exclusive IPs, just for you'],
            ['Reliable and fast'],
            ['Ideal for sensitive tasks'],
        ],
        cta: {caption: 'Try for free >', to: '/dashboard', size: 'md'},
    },
    {
        id: Proxy_type.RES,
        title: 'Rotating Residential Proxies',
        icon: <Icon_rotating_resi/>,
        features: [
            ['New IPs on rotation'],
            ['High anonymity, low detection'],
            ['Versatile for diverse needs'],
        ],
        cta: {caption: 'Try for free >', to: '/dashboard', size: 'md'},
    },
    {
        id: Proxy_type.ISP,
        title: 'Global ISP Proxies',
        icon: <Icon_static_resi/>,
        features: [
            ['Real-world IP addresses'],
            ['Browse like a local'],
            ['Worldwide coverage'],
        ],
        cta: {caption: 'Try for free >', to: '/dashboard', size: 'md'},
    },
    {
        id: Proxy_type.ISPPREM,
        title: 'Search Engine ISP Proxies',
        icon: <Icon_search/>,
        features: [
            ['Search scraping through US only'],
            ['Optimized to avoid blocks'],
            ['Perfect for SEO and Social Mediae'],
        ],
        cta: {caption: 'Try for free >', to: '/dashboard', size: 'md'},
    },
];

type t_product_card_props = i_product_card & {
    shown?: boolean;
    with_icon?: boolean;
};
const Product_card = (props: t_product_card_props)=>{
    const {theme} = useContext(Settings_context);
    const {T} = use_translation_v({no_defaults: true});
    const {id, title, features, cta, icon, shown = false,
        with_icon = false} = props;
    const ref = useRef();
    use_section_scroll(ref, shown, {
        treshold: 0.8,
        part: 'top',
        selector: '.'+styles.container,
        delay: ['', ''].indexOf(id) > -1 ? 700 : 0,
    });
    return <div ref={ref} className={cn(styles.product_card, styles[id])}>
      {with_icon && icon && <div className={styles.icon_wrapper}>{icon}</div>}
      <p className={styles.card_title}><T>{title}</T></p>
      <div className={styles.features} data-elem="card_features">
        {features.map(([name], i)=>{
          return <div key={i} className={styles.feature}>
            <div className={styles.feature_text}>
              <Icon_check/> <p className={cn(theme.p14)}><T>{name}</T></p>
            </div>
          </div>;
        })}
      </div>
      <Button {...cta} fit cls={cn(styles.cta, theme.p16, theme.med)}/>
    </div>;
};

interface i_products_cards_props {
    title?: string;
    title_tag?: string;
    subtitle?: string;
    cards?: i_product_card[];
    shown?: boolean;
    get_cta?: (type?: Proxy_type)=>Partial<i_product_card_cta>;
    bg?: JSX.Element;
    cls?: string;
    skip?: Proxy_type[];
    with_icons?: boolean;
    final_title?: string;
    final_subtitle?: string;
    final_cta?: string;
}
export const Products_cards = (props: i_products_cards_props)=>{
    const {cls, title, subtitle, shown = false, skip = [],
        with_icons = false} = props;
    const {theme} = useContext(Settings_context);
    const {T, t} = use_translation_v({no_defaults: true});
    const ref = useRef();
    use_section_scroll(ref, shown, {
        treshold: 0.8,
        part: 'top',
        selector: '.'+styles.container,
        delay: 0,
    });
    const {pathname} = useLocation();
    const get_data_id =()=>`schema-products-${pathname}`;
    const {data} = use_data_provider(get_data_id);
    const merged_cards: i_product_card[] = React.useMemo(()=>{
        const ssr_products = data?.result?.data;
        const is_valid_ssr = Array.isArray(ssr_products)
            && ssr_products.length > 0;
        if (!is_valid_ssr)
            return product_cards;
        return product_cards.map(card=>{
            const matched = ssr_products.find(p=>
                p.name.trim().toLowerCase() ===
                card.title.trim().toLowerCase());
            const features = Array.isArray(matched?.description)
                ? matched.description.flat().map(line=>[line])
                : card.features;
            const to = matched?.url || card.cta.to;
            return {
                ...card,
                features,
                cta: {
                    ...card.cta,
                    to,
                },
            };
        });
    }, [data?.result?.data]);
    const filtered_cards = !Array.isArray(data?.result?.data) ||
    data.result.data.length === 0 ?
    merged_cards.filter(c=>!skip.includes(c.id)) : merged_cards;
    return <section className={cn(styles.product_cards, cls)}
      id={'hp_products'}>
      {props.bg ?? <div className={styles.bg}/>}
      <div className={styles.wrapper}>
        {title && <Dynamic_heading tag={props.title_tag || 'h2'}>
          <T>{title}</T>
        </Dynamic_heading>}
        {subtitle && <p className={theme.u1}><T>{subtitle}</T></p>}
        <div className={cn(theme.container, styles.container)}
          data-elem="cards_container">
          {filtered_cards.map(c=>{
            const {cta, ...rest} = c;
            const card_cta = {...cta, ...props?.get_cta?.(c.id)};
            return <Product_card key={c.id} {...rest} shown={shown}
              cta={card_cta} with_icon={with_icons}
            />;
          })}
          <div ref={ref} className={cn(styles.product_card, styles.gt)}>
            {with_icons && <Icon_question/>}
            <div className={styles.features}>
              <div className={cn(styles.feature, styles.help)}>
                <p className={styles.card_title}>
                  <T>{props.final_title ||
                    "Not sure which proxy to choose? We're here to help!"}</T>
                </p>
                <p className={cn(theme.p14)}><T>{props.final_subtitle ||
                  `Your needs matter to us - let's find the right fit
                  together.`}</T></p>
                <Button size="sm" cls={styles.cta} round={false}
                  to='mailto:support@toolip.io' color="transparent"
                  caption={t(props.final_cta || 'Get in touch')}/>
              </div>
            </div>
        </div>
        </div>
      </div>
    </section>;
};

interface i_products_cards_editor_props {
  value: {
      title?: string;
      title_tag?:string;
      subtitle?: string;
      final_title?: string;
      final_subtitle?: string;
      final_cta?: string;
  };
  on_change: (val: any)=>void;
}

export const Products_cards_editor = ({value, on_change}:
    i_products_cards_editor_props)=>{
    return <div>
      <Input
        value={value.title || 'The toolip Products'}
        on_change={v=>on_change({...value, title: v})}
        label='Section Title'
      />
      <Title_header_select value={value.title_tag} on_select={v=>
        on_change({...value, title_tag: v})}/>
      <Input
        value={value.subtitle}
        on_change={v=>on_change({...value, subtitle: v})}
        label='Section Subtitle'
      />
      <div style={{border: '1px solid #ccc', padding: '8px', margin: '8px 0'}}>
        <h4>Final Help Card</h4>
        <Input
          value={value.final_title || ''}
          on_change={v=>on_change({...value, final_title: v})}
          label='Help Title'
        />
        <Input
          value={value.final_subtitle || ''}
          on_change={v=>on_change({...value, final_subtitle: v})}
          label='Help Subtitle'
        />
        <Input
          value={value.final_cta || ''}
          on_change={v=>on_change({...value, final_cta: v})}
          label='Help Button Text'
        />
      </div>
    </div>;
};
